;(function () {
  'use strict'

  angular
    .module('contrast.compliance-report')
    .factory('complianceReportService', complianceReportServiceFactory)

  function complianceReportServiceFactory(
    ServiceUtils,
    complianceReportApiConfig
  ) {
    'ngInject'

    var service = {
      getReports: getReports
    }

    return service

    function getReports() {
      return complianceReportApiConfig
        .getReports()
        .then(ServiceUtils.handleResolve('data.reports'))
        .catch(ServiceUtils.handleError)
    }
  }
})()
